// extracted by mini-css-extract-plugin
module.exports = {"section_market":"market_section_market__sGS6Q","icon":"market_icon__s3ZV_","item_group":"market_item_group__U5bID"};